import API from 'api';
import * as C from './constants';
import receiveNetworkException from './network';
import error from './error';
import * as CompanyModels from './models/companies';

export const loadSuccess = (type, res) => ({
  type,
  ...res,
});

export const get = (props) => (dispatch) => {
  dispatch({ type: C.LOAD_COMPANY });
  return API.companies.get(props)
    .then(({ body: { data } }) => (
      dispatch({
        type: C.LOAD_COMPANY_SUCCESS,
        data: CompanyModels.Company(data),
      })
    ))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_COMPANY_ERROR, 'Error loading company'));
    });
};

export const load = (props) => (dispatch) => {
  dispatch({ type: C.LOAD_COMPANIES });
  return API.companies.load(props)
    .then(({ body: { data, meta } }) => ({
      data: CompanyModels.CompaniesList(data),
      meta,
    }))
    .then((res) => dispatch(loadSuccess(C.LOAD_COMPANIES_SUCCESS, res)))
    .catch((e) => {
      dispatch(receiveNetworkException(e));
      return dispatch(error(C.LOAD_COMPANIES_ERROR, 'Error loading companies'));
    });
};

export const setCompany = (company) => (dispatch) => {
  localStorage.setItem('company', JSON.stringify(company));
  localStorage.removeItem('selectedReport');
  return dispatch({ type: C.SET_COMPANY, data: company });
};
